import { render, staticRenderFns } from "./ReceiveDetails_Items.vue?vue&type=template&id=a32ac83a&"
import script from "./ReceiveDetails_Items.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetails_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports